/* Keep the approved bitmap on the physical-pixel grid without changing the header layout. */
(() => {
  let queued = false;
  const align = () => {
    queued = false;
    const dpr = window.devicePixelRatio || 1;
    document.querySelectorAll('.tantomi-web-logo').forEach(img => {
      if (!img.complete || !img.naturalWidth) return;
      img.style.left = '0px';
      img.style.top = '0px';
      img.style.width = '';
      img.style.height = '';
      const initial = img.getBoundingClientRect();
      if (!initial.width) return;
      const width = Math.round(initial.width * dpr) / dpr;
      const height = Math.round(width * dpr * img.naturalHeight / img.naturalWidth) / dpr;
      img.style.width = width + 'px';
      img.style.height = height + 'px';
      const rect = img.getBoundingClientRect();
      img.style.left = (Math.round(rect.left * dpr) / dpr - rect.left) + 'px';
      img.style.top = (Math.round(rect.top * dpr) / dpr - rect.top) + 'px';
    });
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(align); }
  };
  document.addEventListener('load', e => {
    if (e.target instanceof HTMLImageElement && e.target.classList.contains('tantomi-web-logo')) schedule();
  }, true);
  window.addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  document.fonts?.ready.then(schedule);
  schedule();
})();